// Course page slugs, kept apart from the page data so the router can register the
// routes without pulling every page's content into the main bundle.
// The data file uses `satisfies Record<CourseSlug, ...>`, so the two lists cannot drift apart.
export const COURSE_SLUGS = [
  'diploma-computer-science-engg',
  'diploma-mechanical-engg',
  'diploma-civil-engg',
  'diploma-mining-engg',
  'diploma-pharmacy',
  'dmlt',
  'diploma-agriculture',
  'bsc-agriculture',
  'btech-agriculture',
  'btech-computer-science-engg',
  'btech-artificial-intelligence',
  'btech-in-civil-engg',
  'btech-mechanical-engg',
  'btech-mining-engg',
  'btech-data-science',
  'btech-data-science-internet-cyber-security',
  'btech-artificial-intelligence-machine-learning',
  'btech-electronics-communication-engineering',
  'bachelor-of-pharmacy',
  'bachelor-of-pharmacy-dy-2year',
  'bmlt',
  'bba-general',
  'bcom-general',
  'bba-specialization',
  'ba-journalism',
  'bca',
  'bsc-computer-science',
  'bsc-it',
  'bsc-it-data-science',
  'bsc-pcm',
  'bsc-cyber-security',
  'bsc-cbz',
  'bsc-biotechnology',
  'bsc-nursing',
  'btech-quantum-computing',
  'mtech-computer-science-engg',
  'mtech-structural-engg',
  'mtech-transportation-engg',
  'msc-agri-agronomy',
  'msc-agri-horticulture',
  'msc-agri-entomology',
  'msc-agri-plant-pathology',
  'msc-agri-extension-communication',
  'mpharm',
  'msc-physics',
  'msc-mathematics',
  'msc-chemistry',
  'msc-zoology',
  'phd-cse',
  'phd-mechanical',
  'phd-civil',
  'phd-physics',
  'phd-maths',
  'phd-chemistry',
  'phd-management',
  'ba-llb',
  'bba-llb',
  'bcom-llb',
  'bsc-llb',
  'llb-3year',
  'pg-llm-1year',
  // Linked from the Programs Offered list
  'mba-general',
  'mba-agri-business-management',
  'master-of-commerce',
  'msc-biotechnology',
] as const;

export type CourseSlug = (typeof COURSE_SLUGS)[number];
